// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1J4HM","dragIcon":"Choice_dragIcon__1jSIa","left":"Choice_left__36Nmy","input":"Choice_input__1ronw"};